/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_main = [];

const oexMainUpdateSlice = createSlice({
    name: 'oexMainUpdateForm',
    initialState: initialState_main,
    reducers: {
        setMainFormData: (state, action) => {
            return action.payload;
        },
        setMainUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
        addMainForm: (state, action) => {
            addUniqueById(state, action.payload);
        },
        setDeleteData: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((item) => item.id !== idToDelete);
        },
    },
});

export const { setMainFormData, setMainUpdateData, addMainForm, setDeleteData } = oexMainUpdateSlice.actions;
export default oexMainUpdateSlice.reducer;
